import React, { createContext, useContext, useEffect, useState } from 'react';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import useAuth from '../hooks/useAuth';
import * as signalR from '@microsoft/signalr';

const SignalRContext = createContext(null);

export const SignalRProvider = ({ children }) => {
  const [connection, setConnection] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    let hubConnection;

    const connect = async () => {
      try {
        hubConnection = new HubConnectionBuilder()
          .withUrl(process.env.REACT_APP_SIGNALLER_URL, {
            // .withUrl('wss://dispatchapi.ifixgroup.com/dispatchHub', {
            accessTokenFactory: () => {
              return localStorage.getItem('token') || sessionStorage.getItem('token') || '';
            },
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
          })
          .withAutomaticReconnect()
          .configureLogging(LogLevel.Information)
          .build();

        await hubConnection.start();
        setConnection(hubConnection);
      } catch (error) {
        console.error('SignalR connection error:', error);
      }
    };

    if (token) {
      connect();
    }

    return () => {
      if (hubConnection) {
        hubConnection.stop();
      }
      setConnection(null);
    };
  }, [token]);

  return (
    <SignalRContext.Provider value={connection}>
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalR = () => {
  const context = useContext(SignalRContext);
  if (context === undefined) {
    throw new Error('useSignalR must be used within a SignalRProvider');
  }
  return context;
};
